import { render, staticRenderFns } from "./AoikumoSyncBadge.vue?vue&type=template&id=40aec0ae&"
import script from "./AoikumoSyncBadge.vue?vue&type=script&lang=js&"
export * from "./AoikumoSyncBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40aec0ae')) {
      api.createRecord('40aec0ae', component.options)
    } else {
      api.reload('40aec0ae', component.options)
    }
    module.hot.accept("./AoikumoSyncBadge.vue?vue&type=template&id=40aec0ae&", function () {
      api.rerender('40aec0ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/dahreply/AoikumoSyncBadge.vue"
export default component.exports